// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c6252788","453":"c3d18ba1","732":"02960f52","977":"6647feef"}[chunkId] + ".chunk.js";
};